import React from "react";

export default function SQLServer_SESSIONPROPERTY() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQLServer_SESSIONPROPERTY</h1>
      <p>This is the SQLServer_SESSIONPROPERTY component generated from the SQL JSON.</p>
    </div>
  );
}
